export const vendorsResource = {
  name: '商戶',
  fields: {
    id: 'ID',
    name: '商戶名稱',
    code: '商戶代碼',
    vendorType: '商戶類型',
    description: '描述',
    contactName: '聯絡人',
    contactEmail: '聯絡電郵',
    contactPhone: '聯絡電話',
    address: '地址',
    allowedSites: '允許場地',
    isActive: '啟用',
    apiAllowedOperations: '已啟用的 API',
    apiControlLimitPerMinute: '每分鐘啟動及停止請求數',
    apiReadLimitPerMinute: '每分鐘讀取請求數',
    apisEnabled: '已啟用 API',
    createdAt: '創建時間',
    updatedAt: '更新時間',
  },
  types: {
    building_owner: '建築物業主',
    facility_manager: '設施管理商',
    partner: '合作夥伴',
    corporate: '企業',
  },
  sections: {
    basicInfo: '基本資訊',
    contactInfo: '聯絡資訊',
    settings: '設定',
    siteAssignment: '場地分配',
    users: '用戶',
    apiKeys: 'API 金鑰',
    apiAccess: 'API 存取',
  },
  userTypes: {
    backend: '管理員用戶',
    rfid: 'RFID 用戶',
  },
  validation: {
    codeFormat: '只能包含大寫字母、數字和底線',
    integer: '請輸入整數',
  },
  status: {
    active: '啟用',
    inactive: '停用',
  },
  list: {
    subtitle: '管理商戶帳戶以進行 RFID 卡片管理',
  },
  create: {
    title: '創建商戶',
    subtitle: '註冊新的商戶帳戶',
    infoMessage: '商戶是為其員工或客戶管理 RFID 卡片和用戶的外部組織。',
    nameHelperText: '商戶組織的官方名稱',
    codeHelperText: 'API 整合的唯一識別碼（例如：MERCHANT_ABC）',
    vendorTypeHelperText: '選擇商戶組織類型',
    descriptionHelperText: '選填 - 關於此商戶的額外資訊',
    contactNameHelperText: '此商戶的主要聯絡人',
    contactEmailHelperText: '商戶通訊的電子郵件地址',
    contactPhoneHelperText: '緊急事務的電話號碼',
    addressHelperText: '商戶辦公室或帳單地址',
    siteAssignmentInfo: '場地分配',
    siteAssignmentHelperText: '創建商戶後，您可以通過商戶編輯頁面分配他們可以管理的場地。',
    billingInfo: '帳單配置',
    billingHelperText: '如需成本分配，可在創建後配置帳單資訊和設定。',
  },
  edit: {
    title: '編輯商戶',
    subtitle: '更新商戶資訊',
    infoMessage: '管理商戶資訊並分配他們可以管理 RFID 卡片和用戶的場地。',
    nameHelperText: '商戶組織的官方名稱',
    codeHelperText: '唯一識別碼創建後無法更改',
    vendorTypeHelperText: '選擇商戶組織類型',
    descriptionHelperText: '選填 - 關於此商戶的額外資訊',
    contactNameHelperText: '此商戶的主要聯絡人',
    contactEmailHelperText: '商戶通訊的電子郵件地址',
    contactPhoneHelperText: '緊急事務的電話號碼',
    addressHelperText: '商戶辦公室或帳單地址',
    siteAssignmentHelp: '選擇此商戶可以管理 RFID 卡片和用戶的場地。更改會自動保存。',
    searchSites: '搜尋並選擇場地...',
    noSitesAvailable: '沒有可用的場地可供分配',
    noUsers: '此商戶未分配任何用戶。可通過後台用戶或 RFID 卡片部分創建用戶。',
    backendUsersInfo: '後台用戶擁有管理員權限，可為此商戶管理 RFID 卡片和查看報告。',
    rfidUsersInfo: 'RFID 用戶是使用 RFID 卡片充電的員工。他們沒有管理員權限。',
    billingInfo: '帳單配置',
    billingHelperText: '可在此配置帳單資訊和設定以進行成本分配和報告。',
  },
  siteCount: '個場地',
  show: {
    subtitle: '檢視商戶詳情',
  },
  apiKeys: {
    description: 'OAuth 2.0 憑證讓商戶可以驗證身份並使用充電 API。',
    generate: '產生憑證',
    generating: '產生中...',
    copy: '複製憑證',
    noKeys: '尚未產生 OAuth 2.0 憑證。點擊「產生憑證」來建立。',
    noDescription: '無說明',
    neverExpires: '永不過期',
    revokeTooltip: '撤銷憑證',
    loadFailed: '載入 OAuth 2.0 憑證失敗',
    generateSuccess: 'OAuth 2.0 憑證產生成功',
    generateFailed: '產生 OAuth 2.0 憑證失敗',
    revokeSuccess: 'OAuth 2.0 憑證已成功撤銷',
    revokeFailed: '撤銷 OAuth 2.0 憑證失敗',
    clientSecretCopied: '客戶端密鑰已複製到剪貼簿',
    status: {
      active: '使用中',
      expired: '已過期',
      revoked: '已撤銷',
    },
    expiration: {
      days7: '7 天',
      days30: '30 天',
      days60: '60 天',
      days90: '90 天',
      days180: '180 天',
      days365: '1 年(365 天)',
      never: '永不過期',
      custom: '自訂…',
    },
    fields: {
      suffix: '金鑰後綴',
      description: '說明',
      status: '狀態',
      created: '建立時間',
      lastUsed: '最後使用',
      expires: '到期時間',
      actions: '操作',
      expiresInDays: '有效天數',
      expiration: '到期設定',
    },
    generateDialog: {
      title: '產生新的 OAuth 2.0 憑證',
      descriptionHelp: '選填:描述此憑證的用途',
      expiresHelp: '選填:客戶端密鑰將在此天數後到期',
      customExpiresHelp: '請輸入天數(1 天以上)',
      customRequired: '請輸入自訂的有效天數,或選擇其他選項',
      neverExpireWarning: '永不過期的憑證應定期手動更新。請確認您信任憑證接收方。',
      warning: '客戶端密鑰僅會顯示一次。請務必複製並安全保存。',
    },
    revokeDialog: {
      title: '確認撤銷 OAuth 2.0 憑證?',
      body: '您確定要撤銷這組 OAuth 2.0 憑證嗎?此操作無法復原。任何使用此憑證的整合系統將會立即停止運作。',
      confirm: '撤銷',
      revoking: '撤銷中…',
    },
    newKeyDialog: {
      title: 'OAuth 2.0 憑證產生成功',
      important: '重要：這是您唯一能看到客戶端密鑰的機會！',
      saveNow: '請立即複製並保存。您將無法再次取得此密鑰。',
      clientId: '客戶端 ID',
      clientSecret: '客戶端密鑰',
      copied: 'OAuth 2.0 憑證已複製到剪貼簿！',
      usage: '請安全地將這些 OAuth 2.0 憑證分享給商戶。他們將使用它們來取得驗證 API 的存取權杖。',
    },
  },
  apiAccess: {
    help: '選擇此帳戶可以呼叫的 API 端點，以及每分鐘可發出的請求數。取得權杖一律允許。',
    controlLimitHelperText: '適用於啟動及停止呼叫。1 至 10,000。',
    readLimitHelperText: '適用於所有 GET 呼叫。1 至 100,000。',
    selectAll: '全選',
    clear: '清除',
    enabledCount: '已啟用 %{count} / %{total}',
    noneEnabledWarning: '在您啟用至少一個 API 之前，此帳戶無法呼叫任何 API。',
    groups: {
      sites: '場地',
      chargers: '充電樁',
      sessions: '充電時段',
      reports: '報告',
    },
    operations: {
      sitesList: '列出場地',
      chargersList: '列出充電樁',
      chargersGet: '查看單一充電樁',
      sessionsStart: '啟動充電時段',
      sessionsStop: '停止充電時段',
      sessionsList: '列出充電時段',
      sessionsGet: '查看單一充電時段',
      sessionsMeterValues: '讀取充電時段的電錶數值',
      reportsSessions: '充電時段報告',
      reportsSessionsExport: '匯出充電時段 CSV',
    },
  },
};

export const vendors = {
  vendors: vendorsResource,
};